import { motion } from "framer-motion";

// A clean molecular node-graph (hexagonal lattice with connecting bonds)
export const MoleculeGraph = ({ className, stroke = "#0033CC" }) => (
  <svg
    viewBox="0 0 200 200"
    className={className}
    fill="none"
    aria-hidden="true"
  >
    <g stroke={stroke} strokeWidth="1.2" opacity="0.9">
      <line x1="100" y1="30" x2="155" y2="62" />
      <line x1="155" y1="62" x2="155" y2="126" />
      <line x1="155" y1="126" x2="100" y2="158" />
      <line x1="100" y1="158" x2="45" y2="126" />
      <line x1="45" y1="126" x2="45" y2="62" />
      <line x1="45" y1="62" x2="100" y2="30" />
      <line x1="100" y1="30" x2="100" y2="94" />
      <line x1="100" y1="94" x2="155" y2="126" />
      <line x1="100" y1="94" x2="45" y2="126" />
    </g>
    {[
      [100, 30],
      [155, 62],
      [155, 126],
      [100, 158],
      [45, 126],
      [45, 62],
      [100, 94],
    ].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r={i === 6 ? 7 : 5} fill={stroke} />
    ))}
  </svg>
);

// Stylised DNA double helix
export const DnaHelix = ({ className, stroke = "#0033CC" }) => (
  <svg viewBox="0 0 120 320" className={className} fill="none" aria-hidden="true">
    <path
      d="M30 0 C90 40 90 80 30 120 C90 160 90 200 30 240 C90 280 90 320 30 360"
      stroke={stroke}
      strokeWidth="2"
      opacity="0.55"
    />
    <path
      d="M90 0 C30 40 30 80 90 120 C30 160 30 200 90 240 C30 280 30 320 90 360"
      stroke={stroke}
      strokeWidth="2"
      opacity="0.55"
    />
    {Array.from({ length: 14 }).map((_, i) => {
      const y = i * 23 + 8;
      const t = (i % 7) / 7;
      const x1 = 30 + Math.sin(t * Math.PI * 2) * 30 + 30;
      const x2 = 90 - Math.sin(t * Math.PI * 2) * 30 - 30;
      return (
        <line
          key={i}
          x1={i % 2 ? 30 : 90}
          y1={y}
          x2={i % 2 ? 90 : 30}
          y2={y}
          stroke={stroke}
          strokeWidth="1.5"
          opacity="0.35"
        />
      );
    })}
  </svg>
);

export const Hexagon = ({ className, stroke = "#0033CC" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
    <polygon
      points="50,4 92,27 92,73 50,96 8,73 8,27"
      stroke={stroke}
      strokeWidth="1"
      opacity="0.6"
    />
  </svg>
);

export const FloatingShape = ({ children, className, duration = 8, delay = 0 }) => (
  <motion.div
    className={className}
    animate={{ y: [0, -22, 0], rotate: [0, 6, 0] }}
    transition={{ duration, repeat: Infinity, ease: "easeInOut", delay }}
  >
    {children}
  </motion.div>
);

// Continuously animating double helix — base pairs rotate and a wave
// propagates down the strand for a transitional, living-DNA effect.
export const AnimatedDnaHelix = ({ rungs = 22, className, style }) => (
  <div className={`dna-helix-anim ${className || ""}`} style={style} aria-hidden="true">
    {Array.from({ length: rungs }).map((_, i) => {
      const delay = `${(-i * 0.16).toFixed(2)}s`;
      return (
        <div className="dna-rung-anim" key={i}>
          <span className="dna-bond-anim" style={{ animationDelay: delay }} />
          <span className="dna-node-anim dna-node-a" style={{ animationDelay: delay }} />
          <span className="dna-node-anim dna-node-b" style={{ animationDelay: delay }} />
        </div>
      );
    })}
  </div>
);
